import { yesNoOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { CustomerNotes } from "components/table/columnComponents/CustomerNotes"
import { DevicesCount } from "components/table/columnComponents/DevicesCount"
import { FormattedPhoneNumber } from "components/table/columnComponents/PhoneNumber"
import { YesNo } from "components/table/columnComponents/YesNo"

export const getCustomersTableHeaderCells = (showArchived: boolean): UITypes.TableHeaderCell[] => {
  return [
    {
      title: "Email",
      type: "sort-search",
      name: "email",
      cellComponent: CustomerEmail,
    },
    {
      title: "Devices",
      type: "sort-search",
      name: "devices_count",
      size: "small",
      cellComponent: DevicesCount,
    },
    {
      title: "Phone",
      type: "sort-search",
      name: "phone",
      cellComponent: FormattedPhoneNumber,
    },
    {
      title: "Full Name",
      type: "sort-search",
      name: "full_name",
    },
    {
      title: "Customer ID",
      type: "sort-search",
      name: "id",
      size: "middle",
    },
    {
      title: "Membership",
      type: "sort-search",
      name: "membership",
      size: "small",
    },
    {
      title: "Notes",
      type: showArchived ? "default" : "search",
      name: "notes",
      cellComponent: CustomerNotes,
    },
    {
      title: "Mobile App",
      type: showArchived ? "default" : "select",
      name: "app_activated",
      options: yesNoOptions,
      cellComponent: YesNo,
      size: "small",
    },
  ]
}
